import React, {useState, useEffect } from "react";
import  Linktree  from "../components/linkTree";
import Heading from "../components/header";
import Hero from "../components/hero";
import WhiteBlocksDescription from "../components/whiteBlocksDescription";
import BlocksDescription from "../components/blocksDescription";
import Statistics from "../components/statistics";
import Footer from "../components/footer";
import { StaticImage } from "gatsby-plugin-image";
import { graphql } from "gatsby"
import SEO from "../components/seo";
import BannerCookies from "../components/bannerCookies";

import { ContactWidget } from "../components/contactWidget";
import { ContactPopUp } from "../components/contactPopUp";


const Year = new Date().getFullYear();

export const IndexTemplate = ({
     heading,
     hero,
     statistics,
     blocksDescription,
     whiteBlocksDescription,
     linkTree,
     footer
}) => {

     const [isContactWidgetOpen, setIsContactWidgetOpen] = useState(false);

     const changeOpenWidget = () => {
          setIsContactWidgetOpen(!isContactWidgetOpen);
        };
      

     return(
          <>
               <div id="contact-button" className="contact-button">
                    <ContactWidget className="contact-button"  changeOpenWidget={changeOpenWidget}/>

                         {isContactWidgetOpen == true ? (
                              <>
                                   <ContactPopUp changeOpenWidget={changeOpenWidget} />
                              </>
                    ) : <></>}

               </div>

               <BannerCookies></BannerCookies>
               <SEO title="Odontólogo Especialista en Caracas"></SEO>
               <Hero {...hero}></Hero>
               <WhiteBlocksDescription {...whiteBlocksDescription}></WhiteBlocksDescription>
               <BlocksDescription {...blocksDescription}></BlocksDescription>
               <Statistics {...statistics}></Statistics>
               <Linktree {...linkTree}></Linktree>
               <Footer {...footer}></Footer>
          </>
     );
};

const Index = ({data}) => {
     
     const {
          heading,
          hero,
          statistics,
          blocksDescription,
          whiteBlocksDescription,
          linkTree,
          footer
     } = data.markdownRemark.frontmatter;

     return (
          <>
               <IndexTemplate {...{
                    hero,
                    statistics,
                    blocksDescription,
                    whiteBlocksDescription,
                    linkTree,
                    footer
               }}></IndexTemplate>
          </>
     );
};


export const pageQuery = graphql`
{
  markdownRemark(
      frontmatter: { element: { eq: "statistics" } }
  ) {
       frontmatter {
          hero {
	       title {
               text1
               text2
            }
            slogan
            image {
		     id
        		name
        		childImageSharp {
        		     fluid(srcSetBreakpoints: [ 550 ], quality: 90) {
          			...GatsbyImageSharpFluid_withWebp
          		}
      		}
            }
          }
          whiteBlocksDescription {
		     sections {
			     left {
                      image {
                         id
                         childImageSharp {
        				fluid(srcSetBreakpoints: [ 550 ], quality: 90) {
          				...GatsbyImageSharpFluid_withWebp
          			}
      			 }
                    } 
				  content
                    }
               }
          }  
          blocksDescription {
            sections {
              right {
                content
              }
            }
          }  
	     statistics {
                items {
                    number
                    title
                }
			 image {
			     id
        			name
        			childImageSharp {
        				fluid(srcSetBreakpoints: [ 550 ], quality: 90) {
          				...GatsbyImageSharpFluid_withWebp
          			}
      			}
               }
          }
          linkTree {
               title
          }
          footer {
		     info
               policy
               rif
          }
     }
  }
}`;
  
export default Index;
